/* eslint-disable */ /**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * instead, edit its related `.gql` file and recreate it with
 *
 * npm run codegen:pensieve
 */

import * as Types from '../../types/pensieve';

import { api } from 'app/apis/pensieve-gql-api';
export type MentorDash_FetchEarningsSummaryQueryVariables = Types.Exact<{
  start: Types.Scalars['DateTime']['input'];
}>;

export type MentorDash_FetchEarningsSummaryQuery = {
  __typename?: 'Query';
  queue?: { __typename?: 'Queue'; earnings: string } | null;
};

export const MentorDash_FetchEarningsSummaryDocument = `
    query MentorDash_FetchEarningsSummary($start: DateTime!) {
  queue {
    earnings(start: $start)
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    MentorDash_FetchEarningsSummary: build.query<
      MentorDash_FetchEarningsSummaryQuery,
      MentorDash_FetchEarningsSummaryQueryVariables
    >({
      query: (variables) => ({ document: MentorDash_FetchEarningsSummaryDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
